// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".catalog-swiper .swiper-pagination-bullet{width:10px;height:10px}.catalog-swiper .swiper-pagination-bullet-active{background:#2e76e4}.catalog-swiper .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 6px}", ""]);
// Exports
module.exports = exports;
